import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RentVsBuy from "@/pages/RentVsBuy";

export const Route = createFileRoute("/rent-vs-buy")({
  head: () => seoHead("/rent-vs-buy"),
  component: RentVsBuy,
});
